export enum MarkupStrategy {
  Absorbing = "absorbing",
  Additive = "additive",
}
